module.exports = __webpack_public_path__ + "img/btn1.f56a9104.png";